import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { MsalProvider } from '@azure/msal-react';
import { getDynamicComponents } from 'components';
import AvisCookies from 'components/corporatiu/AvisCookies';
import Modal from 'components/corporatiu/Modal';
import ErrorBoundary from 'components/corporatiu/ErrorBoundary';
import Loading from 'components/corporatiu/Loading';
import ServicesListener from 'components/ServicesListener';
import PublicitatProvider from 'context/PublicitatProvider';
import RedlProvider from '../../context/REDL/RedlProvider';
import ProducteProvider from 'context/3cat/ProducteProvider';
import RedlMetadataProvider from 'context/REDL/RedlMetadataProvider';
import ContentUserProvider from 'context/corporatiu/ContentUserProvider';
import GlobalVarsProvider from 'context/GlobalVarsProvider';
import HistoryProvider from 'context/corporatiu/HistoryProvider';
import LoadingProvider from 'context/corporatiu/LoadingProvider';
import ModalProvider from 'context/corporatiu/ModalProvider';
import ServicesProvider from 'context/ServicesProvider';
import UserDelivertyProvider from 'context/UserDelivertyProvider';
import { UserProvider, myMSALObj } from 'context/UserProvider';
import ViewportProvider from 'context/corporatiu/ViewportProvider';
import { useEffect, useState, useRef } from 'react';
import { isEditModeActive } from '@portal-internet/bff';
import { useRouter } from 'next/router';
import styles from '../../../web/styles/clubsuper3/globals.module.scss';

const AppElClub = ({ Component, pageProps }) => {
    const [queryClient] = useState(() => new QueryClient());
    const router = useRouter();
    const isEditMode = isEditModeActive(router?.query);
    const containerRef = useRef(null);

    const DynamicComponents = getDynamicComponents('clubsuper3');

    useEffect(() => {
        const initializeMsal = async () => {
            try {
                await myMSALObj.initialize();
            } catch (error) {
                console.error('Error initializing 3cat MSAL:', error);
            }
        };

        initializeMsal();
    }, []);

    useEffect(() => {
        if (isEditMode) {
            const container = containerRef.current;
            if (!container) return;

            const handleClick = (e) => {
                const link = e.target.closest('a');
                if (link && container.contains(link)) {
                    e.preventDefault();
                    const href = link.getAttribute('href');
                    if (href.startsWith('/')) {
                        window.open(`https://www.3cat.cat${href}`, '_blank');
                    } else {
                        window.open(href, '_blank');
                    }
                }
            };

            container.addEventListener('click', handleClick);
            return () => container.removeEventListener('click', handleClick);
        }
    });

    return (
        <ProducteProvider>
        <ErrorBoundary>
            <GlobalVarsProvider>
                <QueryClientProvider client={queryClient}>
                    <HistoryProvider>
                        <MsalProvider instance={myMSALObj}>
                            <LoadingProvider>
                                <UserDelivertyProvider>
                                    <RedlMetadataProvider>
                                        <RedlProvider>
                                            <ServicesProvider>
                                                <UserProvider>
                                                    <ContentUserProvider>
                                                        <ViewportProvider {...pageProps}>
                                                            <PublicitatProvider>
                                                                <ModalProvider>
                                                                    <AvisCookies {...pageProps} />
                                                                    <div id='__mainContent' className={styles.clubsuper3}>
                                                                        <ServicesListener {...pageProps} />
                                                                        <Component
                                                                            {...pageProps}
                                                                            dynamicComponents={DynamicComponents}
                                                                        />
                                                                        <Loading />
                                                                        <Modal {...pageProps} />
                                                                    </div>
                                                                    <div id='app-modal' className={styles.clubsuper3} />
                                                                    {process.env.isDev === 'true' && (
                                                                        <ReactQueryDevtools initialIsOpen={false} />
                                                                    )}
                                                                </ModalProvider>
                                                            </PublicitatProvider>
                                                        </ViewportProvider>
                                                    </ContentUserProvider>
                                                </UserProvider>
                                            </ServicesProvider>
                                        </RedlProvider>
                                    </RedlMetadataProvider>
                                </UserDelivertyProvider>
                            </LoadingProvider>
                        </MsalProvider>
                    </HistoryProvider>
                </QueryClientProvider>
            </GlobalVarsProvider>
        </ErrorBoundary>
        </ProducteProvider>
    );
};

export default AppElClub;
